exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrapper[data-v-5f04f020]{display:none;margin:12px 24px;border:4px solid #fecc39;border-style:dotted;padding:36px\n}\n@media(max-width: 769px){\n.wrapper[data-v-5f04f020]{padding:24px\n}\n}\n.label[data-v-5f04f020]{font-weight:700;font-size:1.4em;margin-bottom:32px;width:100%;text-align:center\n}\nbutton[data-v-5f04f020]{margin:0 auto;display:block;padding:25px 90px;text-transform:uppercase;border-radius:8px;border:2px solid #fecc39;background-color:#ededed;color:#000;cursor:pointer;font-size:2em;font-weight:700\n}\n@media(max-width: 769px){\nbutton[data-v-5f04f020]{padding:12px 32px\n}\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f04f020","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/register/AlreadyRegistered.vue
// module id = Crzi
// module chunks = 1